module.exports = __webpack_public_path__ + "img/panel_normal.992454ee.svg";